import axios from 'axios';

export const HTTP = axios.create({
    //baseURL: `https://localhost:5001/backoffice/`   
    //baseURL: `https://nova-api4.fpc-france.com/backoffice/`   
    baseURL: process.env.VUE_APP_API_BASE_URL
})